import { ReloadSvg } from '@/components/svgs/ReloadSvg';
import Icon from '@ant-design/icons';
import React from 'react';
import { CustomIconProps } from '../types';

export const ReloadIcon: React.FC<CustomIconProps> = (props) => {
  return <Icon component={ReloadSvg} {...props} />;
};
